import Immutable from 'immutable';
import { combineReducers } from 'redux-immutablejs';

import libraryError from './LibraryErrorReducer';
import internalError from './InternalErrorReducer';

export default combineReducers(
  Immutable.Map({
    libraryError,
    internalError
  })
);
